import React from 'react'

import { isKubernetesAttack } from 'components/attacks/utils/kubernetes'
import Icon from 'components/Icon'
import { haltApiRequest } from 'components/navigation/Notifications/ActiveAttacksList'
import { ActiveApplicationAttackListItem } from 'components/navigation/Notifications/NotificationsList/ListItems/ActiveApplicationAttackListItem'
import { ActiveAttackListItem } from 'components/navigation/Notifications/NotificationsList/ListItems/ActiveAttackListItem'
import { ActiveKubernetesAttackListItem } from 'components/navigation/Notifications/NotificationsList/ListItems/ActiveKubernetesAttackListItem'
import { ActiveScenarioListItem } from 'components/navigation/Notifications/NotificationsList/ListItems/ActiveScenario/ActiveScenarioListItem'
import { LatestScenarioRunProvider } from 'components/navigation/Notifications/NotificationsList/ListItems/ActiveScenario/LatestScenarioRunProvider'
import { NotificationsListSection } from 'components/navigation/Notifications/NotificationsList/NotificationsListSection'
import useAgent from 'hooks/use-agent'
import useAttackResource from 'hooks/use-attack-resource'
import theme from 'theme'

export const ActiveNotificationListSection: React.FC<{
  shouldCollapse: boolean
}> = ({ shouldCollapse }) => {
  const {
    data: [alfiApplicationQueryMetadata, alfiTrafficQueryMetadata],
    isLoading: isLoadingAlfi
  } = useAgent(
    ['/alfi/metadata/applicationQuery', '/alfi/metadata/trafficQuery'],
    [[], []],
    {
      shouldCache: true
    }
  )

  const {
    active: activeAttacks,
    doFetch: doFetchAttacks,
    activeScenarios,
    doFetchActiveScenarios,
    activeApplicationAttacks,
    doFetchApplicationAttacks,
    activeAttacksCount,
    isLoading: isLoadingInfra
  } = useAttackResource({
    completed: false
  })

  return (
    <NotificationsListSection
      isLoading={isLoadingInfra || isLoadingAlfi}
      sectionIcon={
        <Icon
          spinning
          css={{ color: theme.colors.purple[0] }}
          icon="solidArrowsRotate"
        />
      }
      sectionName="active"
      sectionSubTitle="Fault Injections in progress"
      sectionTitle={`Active (${activeAttacksCount})`}
      shouldCollapse={shouldCollapse}
    >
      {activeAttacks?.map((attack, index) =>
        isKubernetesAttack(attack) ? (
          <ActiveKubernetesAttackListItem
            key={`${attack.guid}-${index}`}
            data-test-notification-item
            attack={attack}
            doFetch={doFetchAttacks}
            onConfirmHalt={haltApiRequest}
          />
        ) : (
          <ActiveAttackListItem
            key={`${attack.guid}-${index}`}
            data-test-notification-item
            attack={attack}
            doFetch={doFetchAttacks}
            onConfirmHalt={haltApiRequest}
          />
        )
      )}

      {activeScenarios?.map((scenario, index) => (
        <LatestScenarioRunProvider
          key={`${scenario.guid}-${index}`}
          scenarioId={scenario.guid}
        >
          {(latestRun, isLoading, hasError) =>
            isLoading || hasError ? null : (
              <ActiveScenarioListItem
                data-test-notification-item
                doFetch={doFetchActiveScenarios}
                latestRun={latestRun}
                scenario={scenario}
                onConfirmHalt={haltApiRequest}
              />
            )
          }
        </LatestScenarioRunProvider>
      ))}

      {activeApplicationAttacks?.map((attack, index) => (
        <ActiveApplicationAttackListItem
          key={`${attack.guid}-${index}`}
          data-test-notification-item
          attack={attack}
          doFetch={doFetchApplicationAttacks}
          metadata={{
            applicationQuery: alfiApplicationQueryMetadata,
            trafficQuery: alfiTrafficQueryMetadata
          }}
          onConfirmHalt={haltApiRequest}
        />
      ))}
    </NotificationsListSection>
  )
}
